module.exports = __webpack_public_path__ + "img/status-running-list.f4496083.gif";